export default "__VITE_ASSET__ea64df8c__"